export default __webpack_public_path__ + "static/media/goodreads_rounded.e52ee500.svg";